import React from 'react';
import styled from 'styled-components';
import { colors, typography } from '../../../styles/theme';

const BaseButton = styled.button`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.base};
  font-weight: ${typography.fontWeight.medium};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  border: none;
  
  &:hover {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const PrimaryButton = styled(BaseButton)`
  background: ${colors.primary};
  color: white;
  border-radius: 20px;
  padding: 12px 24px;

  &:hover {
    background: ${colors.primary}dd;
  }
`;

export const ClaimButton = styled(BaseButton)`
  background: #ff6a50;
  color: white;
  border-radius: 20px;
  padding: 12px 24px;

  &:hover {
    background: #FF6B3D;
    transform: translateY(-1px);
  }
`;

export const SecondaryButton = styled(BaseButton)`
  background: transparent;
  color: ${colors.primary};
  border: 1px solid ${colors.primary};
  border-radius: 20px;
  padding: 12px 24px;

  &:hover {
    background: ${colors.primary}11;
  }
`;

export const IconButton = styled(BaseButton)`
  background: transparent;
  color: ${colors.text.secondary};
  padding: 8px;
  border-radius: 8px;

  &:hover {
    color: ${colors.primary};
    background: ${colors.primary}11;
  }
`;

// Common icon components used in buttons
export const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 3.33334V12.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M3.33331 8H12.6666" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
); 